import React from "react";
import { Helmet } from "react-helmet";
import Breadcrumb from "../../shared/breadcrumb/Breadcrumb";
import { useGetVideoGalleryQuery } from "../products/productSlice";
import { useTranslation } from "react-i18next";

// import img1 from "../../assets/img/video/video1.mp4";
// import img2 from "../../assets/img/video/video2.mp4";
// import img3 from "../../assets/img/video/video3.mp4";
// import img4 from "../../assets/img/video/video4.mp4";
// import img5 from "../../assets/img/video/video5.mp4";
// import img6 from "../../assets/img/video/video6.mp4";
import Challenge from "../home/challenge/Challenge";

// const videoData = [
//   { id: "1", video: img1 },
//   { id: "2", video: img2 },
//   { id: "3", video: img3 },
//   { id: "4", video: img4 },
//   { id: "5", video: img5 },
//   { id: "6", video: img6 },
// ];

function VideoGallery() {
  const { data, isLoading } = useGetVideoGalleryQuery();
  const { t, i18n } = useTranslation();

  return (
    <>
      <Helmet>
        <title>Video Gallery | EHL Life Sciences Pvt Ltd</title>
        <meta name="keyword" content="EHL Life Sciences Pvt Ltd" />
        <meta name="description" content="EHL Life Sciences Pvt Ltd" />
      </Helmet>
      <Breadcrumb title="Video Gallery" t={t} />

      <section className="photoGallery p-30">
        <div className="container">
          {/* {isLoading && (
            <div className="preloaderCount">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )} */}
          {/* Gallery */}
          <div className="row">
            <div className="col-lg-12 col-md-12 mb-4 mb-lg-0">
              <div className="pageTitle">
                <h4>Our Video Gallery</h4>
                <p>
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Quasi
                  excepturi fuga nemo vitae possimus repellat, praesentium
                  temporibus officiis, accusamus, labore nostrum aspernatur
                  dolore voluptatibus nesciunt placeat error odio atque ea.
                </p>
              </div>
            </div>

            {/* <div className="row">
              {data &&
                data.map((item, i) => {
                  return (
                    <div
                      className="col-lg-3"
                      key={item._id}
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModalPhoto"
                    >
                      <img
                        style={{ width: "100%" }}
                        src={ImgesData[i].url}
                        className="w-100 shadow-1-strong rounded mb-4"
                        alt="Fertilizer"
                      />
                    </div>
                  );
                })}
            </div> */}
            {/* <div className="galleryPart">
              {videoData.map((item) => {
                return (
                  <div className="modalVideo" key={item.id}>
                    <video
                      width={500}
                      height={240}
                      controls
                      muted
                      autoPlay
                      loop
                    >
                      <source src={item.video} type="video/mp4" />
                    </video>
                  </div>
                );
              })}
            </div> */}
          </div>
        </div>
      </section>

      <Challenge />
    </>
  );
}

export default VideoGallery;
